import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

const selectCompanies = state => state.companies;

export const selectFlattenedCompanies = createSelector(selectCompanies, companies =>
  Object.entries(companies ?? {}).reduce(
    (acc, [key, company]) => ({
      ...acc,
      [key]: {
        companyId: company.id,
        name: company.name,
        companyType: company.type?.type,
        agentVaId: company.lenderInfo?.agentVaId,
        approved: company.approved,
        consentLink: company.consentLink,
        termsLink: company.termsLink,
        isTemplate: company.isTemplate,
        lenderAddress: company.lenderInfo?.address,
        lenderAddress2: company.lenderInfo?.addressLine2 ?? '',
        lenderCity: company.lenderInfo?.city,
        lenderName: company.lenderInfo?.name,
        lenderState: company.lenderInfo?.state?.abbreviation,
        lenderZip: company.lenderInfo?.zip,
        lenderEmailAddress: company.officialEmail,
        lenderNmlsId: company.lenderInfo?.nmlsId,
        lenderPhoneNumber: company.lenderInfo?.phoneNumber,
        lenderFax: company.lenderInfo?.fax,
        lenderWebSite: company.lenderInfo?.webSite,
        privacyPolicyUrl: company.lenderInfo?.privacyPolicyUrl,
        lockNotificationEmail: company.lenderInfo?.lockNotificationEmail,
        fhaLoanLenderIdentifier: company.lenderInfo?.fhaLoanLenderIdentifier,
        fhaLoanSponsorIdentifier: company.lenderInfo?.fhaLoanSponsorIdentifier,
        vaLoanSponsorIdentifier: company.lenderInfo?.vaLoanSponsorIdentifier,
        organizationType: company.lenderInfo?.organizationType,
        incorporationState: company.lenderInfo?.incorporationState?.abbreviation,
        einNumber: company.lenderInfo?.einNumber,
        hmdaFederalAgencyCode: company.lenderInfo?.hmdaFederalAgencyCode,
        parentCompanyId: company.parentCompanyId,
        subCompanyType: company.subCompanyType,
        complianceReportRuleBasisChecklistId: company.complianceReportRuleBasisChecklistId,
        completenessChecklistId: company.completenessChecklistId,
      },
    }),
    {},
  ),
);

const selectCompaniesValues = createSelector(selectFlattenedCompanies, Object.values);

export const selectCompaniesOptions = createSelector(selectCompaniesValues, companies =>
  companies.map(company => ({
    value: company.companyId,
    name: company.name,
  })),
);

export const selectTemplateCompaniesOptions = createSelector(selectCompaniesValues, companies =>
  companies.reduce((acc, i) => {
    if (i.isTemplate) {
      acc.push({ ...i, value: i.companyId });
    }

    return acc;
  }, []),
);

export const selectFilteredCompanies = createSelector(
  getDebouncedSearchValue,
  selectCompaniesValues,
  searchItems(company => [company.name]),
);

export const selectCompanyById = memoizeOne(id =>
  createSelector(selectFlattenedCompanies, companies => companies[id]),
);
